<template>
        <div class="p-6 mt-2 max-w-full bg-white">
    <!-- Header -->
    <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-200 mt-20">
      <h1 class="text-2xl font-bold text-[#035a76]">Contract Renewal</h1>
      <button @click="$emit('back')" class="text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="space-y-10">
      <!-- SECTION 1: Employee Information -->
      <div class="mb-8 p-6 border rounded-lg bg-gray-50">
        <h2 class="text-xl font-semibold mb-6">Employee Information</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <!-- <div>
            <label class="block text-sm font-medium text-gray-700">Select Employee*</label>
            <select 
              v-model="contract.employee" 
              required
              class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"
            >
              <option disabled value="">Select an employee</option>
              <option v-for="applicant in filteredApplicants" :key="applicant.id" :value="applicant.id">
                {{ applicant.name }}
              </option>
            </select>
          </div> -->
          <div>
  <label class="block text-sm font-medium text-gray-700">Select Employee*</label>
  <Multiselect
    v-model="selectedEmployeeModel"
    :options="filteredApplicants"
    :custom-label="app => app.name"
    track-by="id"
    searchable
    placeholder="Search employee..."
    :show-labels="false"
    class="mt-1"
  />
</div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Employee Code</label>
            <input 
              :value="generatedEmployeeCode || 'N/A'" 
              readonly
              class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-gray-100 text-gray-700 font-medium"
              :class="{'border-green-500 ring-2 ring-green-100': hasAcceptedDraft || isRenewalMode}"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Contract Type*</label>
            <select v-model="contract.type" required
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option disabled value="">Select type</option>
              <option v-for="type in contracts" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Duration (months)*</label>
            <input v-model.number="contract.duration" type="number" min="1" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>
        </div>

        <div class="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700">Start Date*</label>
            <input v-model="contract.startDate" type="date" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">End Date</label>
            <input v-model="contract.endDate" type="date"
                   :readonly="contract.autoCalculateEndDate"
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"
                   :class="{'bg-gray-100': contract.autoCalculateEndDate}">

                             <div class="mt-6">
            <div class="flex items-center">
              <input id="auto-calculate" v-model="contract.autoCalculateEndDate" type="checkbox"
                     class="h-4 w-4 text-[#035a76] focus:ring-[#035a76] border-gray-300 rounded">
              <label for="auto-calculate" class="ml-2 block text-sm text-gray-700">
                Auto-calculate end date
              </label>
            </div>
          </div>
          </div>

          <!-- <div>
            <label class="block text-sm font-medium text-gray-700">Emmployee Type</label>
              <select v-model="contract.employeeType"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select type</option>
                <option value="Old">Old</option>
                <option value="New">New</option>
              </select>
          </div> -->
          <div>
              <label class="block text-sm font-medium text-gray-700">Language of Support</label>
              <select v-model="contract.language"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select </option>
                <option value="French">French</option>
                <option value="English">English</option>
              </select>
            </div>
 <div v-if="!isPrefilling && (hasAcceptedDraft || isRenewalMode)" class="mt-4">
          <span v-if="isRenewalMode" class="inline-flex items-center px-3 py-1 rounded text-sm font-medium bg-blue-100 text-blue-800">
            🔄 Renewal Mode
          </span>
          <span v-else class="inline-flex items-center px-3 py-1 rounded text-sm font-medium bg-green-100 text-green-800">
            ✓ Form pre-filled from previous contract
          </span>
        </div>

          <!-- Placeholder for layout balance when not showing extra columns -->
          <div class="hidden lg:block"></div>
          <div class="hidden lg:block"></div>
        </div>

        <div v-if="isPrefilling" class="mt-6 text-sm text-gray-500">
          Loading contract details...
        </div>

       

        <!-- Employee Details Card -->
        <div v-if="(hasAcceptedDraft || isRenewalMode) && !isPrefilling && employeeDetails.name" 
             class="mt-6 bg-white p-5 rounded-md border border-gray-200 shadow-sm">
          <h3 class="text-lg font-medium text-[#035a76] mb-4">Employee Details</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            <div>
              <p class="text-sm text-gray-500">Full Name</p>
              <p class="font-medium text-gray-900">{{ employeeDetails.name }}</p>
            </div>
            <div>
              <p class="text-sm text-gray-500">Current Position</p>
              <p class="font-medium text-gray-900">{{ employeeDetails.position || 'Not specified' }}</p>
            </div>
            <div>
              <p class="text-sm text-gray-500">Department</p>
              <p class="font-medium text-gray-900">{{ employeeDetails.department || 'Not specified' }}</p>
            </div>
            <div v-if="employeeDetails.section">
              <p class="text-sm text-gray-500">Section</p>
              <p class="font-medium text-gray-900">{{ employeeDetails.section }}</p>
            </div>
            <div v-if="employeeDetails.class">
              <p class="text-sm text-gray-500">Class</p>
              <p class="font-medium text-gray-900">{{ employeeDetails.class }}</p>
            </div>
            <div>
              <p class="text-sm text-gray-500">Current Contract End</p>
              <p class="font-medium" :class="{'text-red-600': isExpiring, 'text-gray-900': !isExpiring}">
                {{ formatDate(employeeDetails.contractEndDate) }}
                <span v-if="isExpiring" class="text-xs text-red-500 ml-1">(Expiring Soon)</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- SECTION 2: Contract Terms -->
      <div class="space-y-8">
        <!-- <h2 class="text-xl font-semibold border-b pb-2">Contract Terms</h2> -->

        <!-- <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700">Contract Type*</label>
            <select v-model="contract.type" required
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option disabled value="">Select type</option>
              <option v-for="type in contracts" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Duration (months)*</label>
            <input v-model.number="contract.duration" type="number" min="1" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Probation Period</label>
            <select v-model="contract.probationPeriod"
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option value="0">No probation</option>
              <option value="1">1 month</option>
              <option value="3">3 months</option>
              <option value="6">6 months</option>
            </select>
          </div>
          <div class="hidden lg:block"></div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700">Start Date*</label>
            <input v-model="contract.startDate" type="date" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">End Date</label>
            <input v-model="contract.endDate" type="date"
                   :readonly="contract.autoCalculateEndDate"
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"
                   :class="{'bg-gray-100': contract.autoCalculateEndDate}">
          </div>
          <div class="flex items-center mt-6">
            <input id="auto-calculate" v-model="contract.autoCalculateEndDate" type="checkbox"
                   class="h-4 w-4 text-[#035a76] focus:ring-[#035a76] border-gray-300 rounded">
            <label for="auto-calculate" class="ml-2 block text-sm text-gray-700">
              Auto-calculate end date
            </label>
          </div>
          <div class="hidden lg:block"></div>
        </div> -->

        <!-- Position Details -->
      <div class="mb-8 p-6 border rounded-lg bg-white">
          <h2 class="text-xl font-semibold border-b pb-2 mb-5">Position Details</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Department*</label>
              <select v-model="contract.department" required
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select department</option>
                <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.name }}</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Job Title/Position*</label>
              <select v-model="contract.position" required
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select Position</option>
                <option v-for="position in positions" :key="position.id" :value="position.id">{{ position.name }}</option>
              </select>
            </div>
                     <div>
            <label class="block text-sm font-medium text-gray-700">Probation Period</label>
            <select v-model="contract.probationPeriod"
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option value="0">No probation</option>
              <option value="1">1 month</option>
              <option value="3">3 months</option>
              <option value="6">6 months</option>
            </select>
          </div>
            <!-- spacer -->
            <div class="hidden lg:block"></div>
          </div>

          <!-- Teaching Specific -->
          <div v-if="contract.department == 1" class="mt-8 pt-6 border-t">
            <h3 class="text-lg font-medium mb-4">Teaching Assignment</h3>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700">Section*</label>
                <select v-model="contract.section"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                  <option disabled value="">Select section</option>
                  <option v-for="section in sections" :key="section.id" :value="section.id">{{ section.name }}</option>
                </select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Class Assignment*</label>
                <select v-model="contract.class"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                  <option value="">Select class</option>
                  <option v-for="item in filteredClasses" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Subjects</label>
                <div class="space-y-3 mt-1">
                  <div v-for="(subjectId, index) in contract.subjects" :key="index" class="flex items-center gap-3">
                    <select 
                      v-model="contract.subjects[index]" 
                      class="flex-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                      <option disabled value="">Select a subject</option>
                      <option v-for="subj in subjects" :key="subj.id" :value="subj.id">
                        {{ subj.name }} {{ subj.code ? `(${subj.code})` : '' }}
                      </option>
                    </select>
                    <button 
                      v-if="contract.subjects.length > 1" 
                      @click="removeSubject(index)" 
                      type="button"
                      class="text-red-600 hover:text-red-800 p-2"
                      title="Remove subject"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <button 
                    @click="addSubject" 
                    type="button"
                    class="mt-2 inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded text-[#035a76] bg-[#035a76]/10 hover:bg-[#035a76]/20"
                  >
                    + Add Subject
                  </button>

                  <div v-if="contract.subjects.some(id => id)" class="mt-2 text-xs text-gray-500">
                    Selected: {{ selectedSubjectNames }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Salary + Termination side by side -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <!-- Salary & Benefits -->
        <div class="mb-8 p-6 border rounded-lg bg-white">
          <h2 class="text-xl font-semibold border-b pb-2 mb-6">Salary & Benefits</h2>
          
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div v-if="hasPermission('contracts', 'view_salary')">
              <label class="block text-sm font-medium text-gray-700">Base Salary (GHS)*</label>
              <input v-model.number="contract.salary" type="number" min="0" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Payment Frequency*</label>
              <select v-model="contract.paymentFrequency" required
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option value="monthly">Monthly</option>
                <option value="bi-weekly">Bi-Weekly</option>
                <option value="weekly">Weekly</option>
              </select>
            </div>
              <div>
              <label class="block text-sm font-medium text-gray-700">Leave Days*</label>
              <input v-model.number="contract.leaveDays" type="number" min="0" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">SSNIT Contribution</label>
              <select v-model="contract.ssnit"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

          <div class="mt-6" v-if="hasPermission('contracts', 'view_benefit')">
            <label class="block text-sm font-medium text-gray-700">
              Additional Benefits
            </label>
          
            <!-- Yes / No Select -->
            <select

              v-model="contract.hasBenefits"
              class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"
            >
              <option disabled value="">Select benefits</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          
            <!-- Conditional Fields -->
<div v-if="contract.hasBenefits === 'Yes'">
  <label class="block text-sm font-medium text-gray-700 mt-4">Benefits</label>

  <div class="space-y-3 mt-1">
    <div
      v-for="(benefit, index) in contract.benefits"
      :key="index"
      class="flex items-center gap-3"
    >
      <!-- Select -->
      <select
        v-model="benefit.type_id"
        class="flex-1 border border-gray-300 rounded-md py-2 px-3"
      >
        <option disabled value="">Select benefit</option>
        <option v-for="b in benefits" :key="b.id" :value="b.id">
          {{ b.name }}
        </option>
      </select>

      <!-- Amount -->
      <input
        type="number"
        v-model="benefit.amount"
        placeholder="Amount"
        class="w-32 border border-gray-300 rounded-md py-2 px-3"
      />

      <!-- Remove -->
      <button
        v-if="contract.benefits.length > 1"
        @click="removeBenefit(index)"
        type="button"
        class="text-red-600 hover:text-red-800 p-1"
      >
        ✕
      </button>
    </div>

    <!-- Add button -->
    <button
      @click="addBenefit"
      type="button"
      class="mt-2 inline-flex items-center px-3 py-1 text-sm rounded text-[#035a76] bg-[#035a76]/10 hover:bg-[#035a76]/20"
    >
      + Add Benefit
    </button>
    <div v-if="Array.isArray(contract.benefits) && contract.benefits.some(b => b.type || b.amount)" class="mt-2 text-xs text-gray-500">
  Selected: {{ selectedBenefitNames }}
</div>
  </div>
</div>
          </div>
        </div>

        <!-- Termination -->
        <div class="mb-8 p-6 border rounded-lg bg-white">
          <h2 class="text-xl font-semibold border-b pb-2 mb-6">Termination Clause</h2>
          
          <div class="flex items-center mb-4">
            <input id="include-termination" v-model="contract.includeTermination" type="checkbox"
                   class="h-4 w-4 text-[#035a76] focus:ring-[#035a76] border-gray-300 rounded">
            <label for="include-termination" class="ml-2 block text-sm text-gray-700">
              Include termination clause
            </label>
          </div>
          
          <div v-if="contract.includeTermination" class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700">Notice Period (days)*</label>
                <input v-model.number="contract.noticePeriod" type="number" min="1"
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Termination Reason Required</label>
                <select v-model="contract.terminationReasonRequired"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700">Termination Conditions</label>
              <textarea v-model="contract.terminationConditions" rows="3"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex justify-end space-x-4 mt-10 pt-6 border-t border-gray-200">
        <button
  v-if="existingDraft?.id"
  type="button"
  @click="updateContract"
  :disabled="isSaving"
  class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700"
>
  {{ isSaving ? 'Updating...' : 'Update Draft' }}
</button>
        <button type="button" @click="resetForm"
                class="inline-flex items-center px-5 py-2.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
          Reset
        </button>
        <button 
          type="button" 
          @click="saveContract" 
          :disabled="isSaving || hasAcceptedDraft"
          class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-amber-500 hover:bg-amber-600 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500">
          {{ isSaving ? 'Saving...' : 'Generate Draft' }}
        </button>
        <button 
          type="button" 
          @click="generateContract"
          :disabled="isSaving || !hasAcceptedDraft"
          class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#76ba51] hover:bg-[#66a345] disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
          {{ isSaving ? 'Generating...' : 'Save Contract' }}
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script setup>
  import { ref, watch, computed, onMounted } from 'vue';
  import api from "@/services/api"
  import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
//   import HrSidebar from '../../components/hr/HrSidebar.vue';
//   import HrTopbar from '../../components/hr/HrTopbar.vue';

//   const isSidebarOpen = ref(true);
//   const isDarkMode = ref(false);
//   const selectedPeriod = ref('month');

const applicants = ref([]);
const selectedEmployee = ref(""); 

const contracts = ref([]);

const departments = ref([]);

const positions = ref([]);

const sections = ref([]);

const classes = ref([]);

const subjects = ref([]);

const benefits = ref([]);

const generatedEmployeeCode = ref('');
const isPrefilling = ref(false);
const hasAcceptedDraft = ref(false);
const isSaving = ref(false);
const existingDraft = ref(null);
const isRenewalMode = ref(false);

import { usePermissions } from '@/composables/usePermissions'

const { hasPermission } = usePermissions()

// ... after your existing refs ...

// ✅ ADD THIS - Employee Details Computed (pulls from existingDraft)
const employeeDetails = computed(() => {
  if (existingDraft.value) {
    return {
      name: existingDraft.value.employee_name || '',
      position: existingDraft.value.position_title || '',
      department: existingDraft.value.department_name || '',
      section: existingDraft.value.section_name || '',
      class: existingDraft.value.class_name || '',
      contractEndDate: existingDraft.value.end_date || ''
    };
  }
  return {
    name: '',
    position: '',
    department: '',
    section: '',
    class: '',
    contractEndDate: ''
  };
});

// Now your isExpiring will work
const isExpiring = computed(() => {
  if (!employeeDetails.value.contractEndDate) return false;
  
  const endDate = new Date(employeeDetails.value.contractEndDate);
  const today = new Date();
  const daysUntilExpiry = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
  
  return daysUntilExpiry <= 60 && daysUntilExpiry >= 0;
});

// ✅ Format date helper
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

const selectedSubjectNames = computed(() => {
  if (!contract.value.subjects) return "";

  return contract.value.subjects
    .map(id => {
      const subject = subjects.value.find(s => String(s.id) === String(id));
      return subject ? subject.name : null;
    })
    .filter(Boolean)
    .join(", ");
});
const selectedBenefitNames = computed(() => {
  if (!contract.value.benefits || !Array.isArray(contract.value.benefits)) return "";
  
  return contract.value.benefits
    .map(b => {
      // Match type_id with benefits[].id
      const benefit = benefits.value.find(s => String(s.id) === String(b.type_id));
      return benefit ? benefit.name : null;
    })
    .filter(Boolean)
    .join(", ");
});

const selectedEmployeeModel = computed({
  get() {
    if (!contract.value.employee) return null;
    return filteredApplicants.value.find(app => String(app.id) === String(contract.value.employee)) || null;
  },
  set(newValue) {
   
    contract.value.employee = newValue ? newValue.id : '';
  }
});
const fetchApplicants = async () => {
  try {
    const response = await api.get("Applicants.php");

    applicants.value = response.data.map(applicant => ({
      id: applicant.id,
      name: applicant.full_name,
      position: applicant.position_title,
      status: applicant.applicant_status,

    }));

  } catch (error) {
    console.error("Error fetching Applicants:", error);
  }
}
const fetchBenefits = async () => {
  try {
    const response = await api.get("BenefitTypes.php");
    
    // ✅ Handle { success: true, data: [...] } format
    const benefitData = response.data.success 
      ? response.data.data 
      : response.data;
    
    if (Array.isArray(benefitData)) {
      benefits.value = benefitData.map(b => ({
        id: b.id,
        name: b.name,
        code: b.code ?? '',
        description: b.description ?? ''
      }));
      console.log(`✅ Loaded ${benefits.value.length} benefit types`);
    }
  } catch (error) {
    console.error("❌ Error fetching Benefit Types:", error);
    // Optional: Fallback mock data
    // benefits.value = [
    //   { id: 1, name: 'Food Allowance', code: 'FA' },
    //   { id: 2, name: 'Transport Allowance', code: 'TA' },
    //   { id: 3, name: 'Rent Allowance', code: 'RA' }
    // ];
  }
};
const filteredApplicants = computed(() => {
  return applicants.value.filter(applicant => applicant.status?.toLowerCase() === "hired");
});
const fetchContractType = async () => {
  try{
    const response = await api.get("ContractType.php");
    contracts.value = response.data.map(contract => ({
      id:contract.id,
      name:contract.name,
      code:contract.code,
      description:contract.description,
      duration:contract.duration
    }));

  } catch (error) {
    console.error("Error fetching COntract Types:", error);
  }
};
const fetchDepartments = async () => {
  try{
    const response = await api.get("Departments.php");
    departments.value = response.data.map(department => ({
      id:department.id,
      name:department.name,
      code:department.code,
      description:department.description
    }));

  } catch (error) {
    console.error("Error fetching Departments:", error);
  }
};

const fetchPositions = async () => {
  try {
    const response = await api.get("Positions.php");

    positions.value = response.data.map(position => ({
      id: position.id,
      department_id: position.department_id,
      department_name : position.department_name,
      name: position.title,
      code: position.code,
      description: position.description
    }));

  } catch (error) {
    console.error("Error fetching Positions:", error);
  }
};
const fetchSections = async () => {
  try{
    const response = await api.get("Sections.php");
    sections.value = response.data.map(section => ({
      id:section.id,
      name:section.name,
      code:section.code,
      description:section.description
    }));

  } catch (error) {
    console.error("Error fetching Sections:", error);
  }
};
const fetchClasses = async () => {
  try {
    const response = await api.get("Classes.php");

    classes.value = response.data.map(item => ({
      id: item.id,
      section_id: item.section_id,
      section_name: item.section_name,
      name: item.name,
      code: item.code,
      description: item.description
    }));

  } catch (error) {
    console.error("Error fetching Classes:", error);
  }
};
const fetchSubjects = async () => {
  try{
    const response = await api.get("Subjects.php");
    subjects.value = response.data.map(subject => ({
      id:subject.id,
      name:subject.name,
      code:subject.code,
      description:subject.description
    }));

  } catch (error) {
    console.error("Error fetching Subjects:", error);
  }
};
const filteredClasses = computed(() => {
  if (!contract.value.section) return [];

  const selectedSectionId = contract.value.section; // already string or number from v-model

  return classes.value.filter(cls => 
    String(cls.section_id) === String(selectedSectionId)
  );
});
  
  // Mock employee data - replace with API call in production
  // const employees = ref([
  //   { id: 'EMP001', name: 'Kwame Mensah', position: 'Teacher', department: 'Academics' },
  //   { id: 'EMP002', name: 'Ama Serwaa', position: 'Accountant', department: 'Finance' },
  //   { id: 'EMP003', name: 'Yaw Boateng', position: 'Administrator', department: 'Administration' },
  // ]);
  
// const selectedEmployeeDetails = computed(() => {
//   return filteredApplicants.value.find(app => app.id === selectedEmployee.value) || null;
// });

const selectedEmployeeDetails = computed(() => {
  return filteredApplicants.value.find(app => app.id === selectedEmployee.value) || null;
});
  
  const emit = defineEmits(['back', 'submit']);

  const contract = ref({
    employee: '',
    type: '',
    duration: 12,
    probationPeriod: '3',
    startDate: '',
    endDate: '',
    autoCalculateEndDate: true,
    department: '',
    position: '',
    section: '',
    class: '',
    subjects: [''],
    salary: 0,
    paymentFrequency: 'monthly',
    ssnit: '',
    hasBenefits: "Yes",
    benefits: [{ type_id: '', amount: '' }],
    includeTermination: true,
    noticePeriod: 30,
    terminationReasonRequired: 'Yes',
    terminationConditions: 'Either party may terminate this contract by providing written notice as specified in the notice period section.'
  });
  
  // Watch for changes to auto-calculate end date
  watch(() => [contract.value.startDate, contract.value.duration, contract.value.autoCalculateEndDate], 
    ([startDate, duration, autoCalculate]) => {
      if (autoCalculate && startDate && duration) {
        const start = new Date(startDate);
        start.setMonth(start.getMonth() + parseInt(duration));
        contract.value.endDate = start.toISOString().split('T')[0];
      }
    },
    { deep: true }
  );
  
  // Methods
  const addSubject = () => {
    contract.value.subjects.push('');
  };
  
  const removeSubject = (index) => {
    contract.value.subjects.splice(index, 1);
  };
    const addBenefit = () => {
  contract.value.benefits.push({
    type_id: '',
    amount: ''
  });
};
  
 const resetForm = () => {
  contract.value = {
    employee: '',
    type: '',
    duration: 12,
    probationPeriod: '3',
    startDate: '',
    endDate: '',
    autoCalculateEndDate: true,
    department: '',
    position: '',
    section: '',
    class: '',
    subjects: [''],
    salary: 0,
    paymentFrequency: 'monthly',
    ssnit: '',
    hasBenefits: "Yes",
    // ✅ Same fix here
    benefits: [{ type_id: '', amount: '' }],
    includeTermination: true,
    noticePeriod: 30,
    terminationReasonRequired: 'Yes',
    terminationConditions: 'Either party may terminate this contract by providing written notice as specified in the notice period section.'
  };
};
  
  // const saveDraft = () => {
  //    // Basic validation
  // if (!contract.value.employee || !contract.value.type || !contract.value.department) {
  //   alert('Please fill all required fields before saving draft');
  //   return;
  // }
  
  // };


// Save Contract Function
const saveContract = async () => {
  // Validate required fields
  if (!contract.value.employee) {
    alert('Please select an employee');
    return;
  }
  if (!contract.value.type) {
    alert('Please select contract type');
    return;
  }
  if (!contract.value.startDate) {
    alert('Please select start date');
    return;
  }
  if (!contract.value.salary) {
    alert('Please enter salary');
    return;
  }
  
  try {
    isSaving.value = true;
    
    // Prepare data (remove empty subjects)
    const payload = {
      employee: contract.value.employee,
      type: contract.value.type,
      duration: contract.value.duration,
      probationPeriod: contract.value.probationPeriod,
      startDate: contract.value.startDate,
      endDate: contract.value.endDate,
      department: contract.value.department,
      position: contract.value.position,
      section: contract.value.section || null,
      class: contract.value.class || null,
      subjects: contract.value.subjects.filter(s => s !== ''),
      salary: contract.value.salary,
      paymentFrequency: contract.value.paymentFrequency,
      ssnit: contract.value.ssnit,
      benefits: contract.value.benefits,
      noticePeriod: contract.value.noticePeriod,
      terminationReasonRequired: contract.value.terminationReasonRequired,
      terminationConditions: contract.value.terminationConditions
    };
    
    // Call API
    const response = await api.post('SaveContract.php', payload);
    
    if (response.data.success) {
      alert('✅ Contract saved! Ref: ' + response.data.contract_number);
      console.log('Contract ID:', response.data.contract_id);
    } else {
      alert('❌ Error: ' + response.data.error);
    }
    
  } catch (error) {
    console.error(error);
    alert('❌ Failed to save contract');
  } finally {
    isSaving.value = false;
  }
};
  
// Generate Contract - Insert into employee_contracts table
const generateContract = async () => {
  // Validation
  if (!contract.value.employee) {
    alert('Please select an employee');
    return;
  }
  
  if (!hasAcceptedDraft.value) {
    alert('No accepted draft found. Please save and submit a contract first.');
    return;
  }
  
  if (!generatedEmployeeCode.value) {
    alert('Employee code not generated. Please refresh and try again.');
    return;
  }
  
  // Confirm action
  if (!confirm('Generate contract for ' + selectedEmployeeDetails.value?.name + '?')) {
    return;
  }
  
  try {
    isSaving.value = true;
    
    // We need the draft ID - fetch it from the existing draft data
    // You may need to store draft.id when prefilling
    const draftId = existingDraft.value?.id || 0;
    
    const payload = {
      applicant_id: contract.value.employee,
      draft_id: draftId,
      employee_code: generatedEmployeeCode.value
    };
    
    const response = await api.post('FinalizeContract.php', payload);
    
    if (response.data.success) {
      alert('✅ Contract generated successfully!\nEmployee Code: ' + generatedEmployeeCode.value);
      
      // Optional: Reset form or redirect
      resetForm();
      // Or emit event to parent component
      emit('submit', {
        contractId: response.data.contract_id,
        employeeCode: generatedEmployeeCode.value
      });
    } else {
      throw new Error(response.data.error || 'Failed to generate contract');
    }
    
  } catch (error) {
    console.error('Generate contract error:', error);
    alert('❌ Error: ' + error.message);
  } finally {
    isSaving.value = false;
  }
};

watch(() => contract.value.section, () => {
  contract.value.class = "";
});

// Watch for employee selection and check for accepted draft
watch(() => contract.value.employee, async (newApplicantId) => {
  // Reset when no employee selected
  if (!newApplicantId) {
    resetFormFields();
    generatedEmployeeCode.value = '';
    hasAcceptedDraft.value = false;
    existingDraft.value = null;
    return;
  }
  
  await loadContractForRenewal(newApplicantId);
});



const loadContractForRenewal = async (applicantId) => {
  try {
    isPrefilling.value = true;
    hasAcceptedDraft.value = false;
    
    const response = await api.post('GetContractForRenewal.php', {
      applicant_id: applicantId
    });
    
    if (response.data.success && response.data.draft) {
      hasAcceptedDraft.value = true;
      generatedEmployeeCode.value = response.data.employee_code;
      
      // ✅ Reuse the SAME prefill function - no changes needed!
      prefillFormFromDraft(response.data.draft);
      
      console.log('✅ Contract loaded for renewal');
    } else {
      resetForm();
    }
  } catch (error) {
    console.error('Error loading renewal:', error);
  } finally {
    isPrefilling.value = false;
  }
};

// Prefill ALL form fields from draft data
const prefillFormFromDraft = (draft) => {
  existingDraft.value = draft;
  contract.value = {
    ...contract.value,
    
    // Basic
    employee: draft.applicant_id,
    
    // Contract Type
    type: draft.contract_type_id || '',
    
    // Duration (keep default or calculate)
    duration: 12,
    
    // Probation
    probationPeriod: draft.probation_end_date ? '3' : '0',
    
    // Dates
    startDate: draft.start_date || '',
    endDate: draft.end_date || '',

    language: draft.language || '',
    
    // Position
    department: draft.department_id || '',
    position: draft.position_id || '',
    
    // Teaching fields
    section: draft.section_id || '',
    class: draft.class_id || '',
    
    // Subjects: convert "1,2,3" string to ["1","2","3"] array
subjects: draft.subjects && draft.subjects.length > 0 
      ? draft.subjects.map(subj => String(subj.id))  // Extract IDs as strings
      : [''],
    
    // Salary & Benefits
    salary: draft.basic_salary || 0,
    paymentFrequency: draft.payment_frequency || 'monthly',
    ssnit: draft.ssnit || 'No',
    hasBenefits: draft.hasBenefits || 'No',
    leaveDays:draft.leave_days || '',
// In prefillFormFromDraft():
benefits: Array.isArray(draft.benefits) && draft.benefits.length > 0
  ? draft.benefits.map(b => ({
      type_id: b.benefit_type_id,  // ✅ Flat: matches template & computed
      amount: b.amount
    }))
  : [{ type_id: '', amount: '' }],    
    // Termination
    includeTermination: draft.termination_required === 'Yes',
    noticePeriod: draft.notice_period_days || 30,
    terminationReasonRequired: draft.termination_required || 'No',
    terminationConditions: draft.termination_condition || ''
  };
  //   setTimeout(() => {
  //   contract.value.terminationReasonRequired = draft.termination_required || 'No';
  //   console.log('✅ Forced termination value after timeout:', contract.value.terminationReasonRequired);
  // }, 10);
};

// Reset form fields but keep employee selection
const resetFormFields = () => {
  contract.value = {
    employee: contract.value.employee, 
    type: '',
    duration: 12,
    probationPeriod: '3',
    startDate: '',
    endDate: '',
    autoCalculateEndDate: true,
    department: '',
    position: '',
    section: '',
    class: '',
    subjects: [''],
    salary: 0,
    paymentFrequency: 'monthly',
    ssnit: 'No',
    benefits: '',
    includeTermination: true,
    noticePeriod: 30,
    terminationReasonRequired: 'No',
    terminationConditions: ''
  };
  
  // Clear draft-related state
  generatedEmployeeCode.value = '';
  hasAcceptedDraft.value = false;
  existingDraft.value = null;
};

  onMounted(() => {
    fetchApplicants();
    fetchContractType();
    fetchDepartments();
    fetchPositions();
    fetchSections();
    fetchClasses();
    fetchSubjects();
    fetchBenefits();
  })
  </script>
  
  <style scoped>
  /* Add any custom styles here */
  </style>